var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgComment = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 66,
    height: 66,
    fill: "#4072ee",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.014,23.666c-.595,0-1.196-.21-1.675-.636l-3.598-3.03H0V3.5C0,1.57,1.57,0,3.5,0H20.5c1.93,0,3.5,1.57,3.5,3.5V20h-6.671l-3.708,3.065c-.448,.399-1.024,.601-1.606,.601Zm-.318-2.901l-.028,.023,.028-.023Zm.59-.017l.016,.014-.016-.014Zm-9.286-3.749H7.836l4.167,3.511,4.245-3.511h4.751V3.5c0-.276-.225-.5-.5-.5H3.5c-.276,0-.5,.224-.5,.5v13.5Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgComment);
export default ForwardRef;